import { JURISDICTIONS } from '../config';
/* eslint-disable @typescript-eslint/no-explicit-any */
const enrichWithCommonInfo = (payload) => {
    return window.AnalyticsTactical.Sports.localHelpers.enrichWithCommonInfo(payload);
};
export const track = (event, payload, jurisdiction) => {
    // TODO - use sb/analytics implementation
    if (jurisdiction === JURISDICTIONS.es)
        return;
    if (window.AnalyticsTactical) {
        window.AnalyticsTactical.Helpers.sendData(event, enrichWithCommonInfo(payload));
    }
};
//# sourceMappingURL=analytics.js.map